/* High-converting product page — shared behaviour for all hc-* sections.
   Safe to load once per page; every piece guards itself and re-runs
   correctly when the theme editor reloads a single section. */
(function () {
  /* The stylesheet/script tag is emitted by every hc-* section, so on a page
     with 19 of them the browser executes this file 19 times. Everything below
     is idempotent per element, but the document-level listeners are not — so
     bail out on every run after the first. */
  if (window.__hcPageInit) return;
  window.__hcPageInit = 1;

  function ph(label, i, wide) {
    var svg = wide
      ? "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 80'><rect width='320' height='80' rx='8' fill='none' stroke='#0B8A4B' stroke-opacity='.45' stroke-width='3' stroke-dasharray='8 6'/><text x='160' y='48' font-family='sans-serif' font-size='22' font-weight='700' fill='#0B8A4B' fill-opacity='.65' text-anchor='middle'>" + String(label).toUpperCase() + "</text></svg>"
      : "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400'><rect width='400' height='400' fill='" + ["#DFF0E4", "#D5EADB", "#E6F4EA"][i % 3] + "'/><circle cx='200' cy='166' r='44' fill='none' stroke='#0B8A4B' stroke-opacity='.35' stroke-width='6'/><path d='M200 140c0 20 12 34 30 34 0-20-12-34-30-34zm0 0c0 20-12 34-30 34 0-20 12-34 30-34zm0 34v32' fill='none' stroke='#0B8A4B' stroke-opacity='.45' stroke-width='6' stroke-linecap='round'/><text x='200' y='262' font-family='sans-serif' font-size='19' font-weight='600' fill='#0B8A4B' fill-opacity='.7' text-anchor='middle'>" + label + "</text></svg>";
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;

    /* 1. placeholder art for image slots with no image chosen yet */
    root.querySelectorAll('img[data-ph]').forEach(function (img, i) {
      if (img.dataset.phDone) return;
      img.dataset.phDone = '1';
      if (!img.getAttribute('src')) {
        img.src = ph(img.getAttribute('data-ph'), i, !!img.closest('.hc-press-row'));
        img.classList.add('ph');
      }
    });

    /* 2. product gallery */
    root.querySelectorAll('[data-hc-gallery]').forEach(function (gal) {
      if (gal.dataset.hcDone) return;
      gal.dataset.hcDone = '1';
      var main = gal.querySelector('[data-hc-main]');
      var thumbs = gal.querySelectorAll('[data-hc-thumb]');
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          var im = b.querySelector('img');
          if (main) main.src = b.getAttribute('data-full') || (im && im.src) || main.src;
          thumbs.forEach(function (o) { o.setAttribute('aria-current', o === b ? 'true' : 'false'); });
        });
      });
    });

    /* 3. marquees — clone the set so the loop is seamless */
    root.querySelectorAll('[data-hc-track]').forEach(function (track) {
      if (track.dataset.hcDone) return;
      track.dataset.hcDone = '1';
      var set = track.querySelector('[data-hc-set]');
      if (!set || !set.children.length) return;
      /* if one set is narrower than the viewport, repeat it first so the
         strip always fills the width before we duplicate for the loop */
      var guard = 0;
      while (set.scrollWidth < (track.parentElement.clientWidth || 0) && guard < 8) {
        Array.prototype.slice.call(set.children).forEach(function (c) {
          set.appendChild(c.cloneNode(true));
        });
        guard++;
      }
      var copy = set.cloneNode(true);
      copy.removeAttribute('data-hc-set');
      copy.setAttribute('aria-hidden', 'true');
      track.appendChild(copy);

      /* The speed setting is seconds-per-loop, which means a long strip on a wide
         desktop crawls while the same strip on a phone races. Convert it to a
         constant pixels-per-second so it reads the same at every width: treat the
         setting as the time one PHONE-WIDTH of content should take to pass. */
      var speed = parseFloat(getComputedStyle(track).getPropertyValue('--speed')) || 48;
      var pxPerSec = 1600 / speed;                    /* 1600px is the reference strip */
      var dist = set.scrollWidth + 12;                /* one set + the gap */
      track.style.animationDuration = Math.max(6, dist / pxPerSec) + 's';

      track.classList.add('on');
    });

    /* 5. delivery estimate — recompute from the viewer's own clock */
    root.querySelectorAll('[data-hc-eta]').forEach(function (el) {
      if (el.dataset.hcDone) return;
      el.dataset.hcDone = '1';
      var days = parseInt(el.getAttribute('data-hc-eta'), 10);
      var slot = el.querySelector('[data-hc-eta-date]');
      if (!slot || isNaN(days)) return;
      var d = new Date();
      d.setDate(d.getDate() + days);
      var short = el.getAttribute('data-hc-eta-format') === 'short';
      try {
        slot.textContent = d.toLocaleDateString(undefined, {
          weekday: short ? 'short' : 'long',
          day: 'numeric',
          month: short ? 'short' : 'long'
        });
      } catch (e) { /* keep the server-rendered date */ }
    });


    /* 6. video poster — load the embed only when someone taps play */
    root.querySelectorAll('[data-hc-video-play]').forEach(function (btn) {
      if (btn.dataset.hcDone) return;
      btn.dataset.hcDone = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-hc-video]');
        var tpl = wrap && wrap.querySelector('[data-hc-video-embed]');
        if (!tpl) return;
        wrap.innerHTML = '';
        wrap.appendChild(tpl.content.cloneNode(true));
      });
    });

    /* 4. smooth scroll to the buy box */
    /* Scroll to the buy box rather than reloading the page.
       Shopify's own Add to cart lives in .buy-buttons-block; the rest are
       fallbacks so this keeps working if Horizon renames something. */
    function buyBox() {
      var sels = ['.buy-buttons-block', 'product-form-component', '.product-form-buttons',
                  '[id^="ProductInformation-"]', '#hc-buy'];
      for (var i = 0; i < sels.length; i++) {
        var el = document.querySelector(sels[i]);
        if (el) return el;
      }
      return null;
    }
    function headerOffset() {
      var h = document.querySelector('#header-component, .header-component, header');
      var n = h ? h.getBoundingClientRect().height : 0;
      return (n > 0 && n < 220 ? n : 0) + 14;
    }
    root.querySelectorAll('[data-hc-jump]').forEach(function (a) {
      if (a.dataset.hcDone) return;
      a.dataset.hcDone = '1';
      a.addEventListener('click', function (e) {
        var raw = a.getAttribute('data-hc-jump');
        /* resolved at click time, not at load, so it survives section reloads */
        var target = (!raw || raw === 'buybox') ? buyBox() : document.querySelector(raw);
        if (!target) return;               /* no target -> let the href do its job */
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        try {
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        } catch (err) {
          window.scrollTo(0, Math.max(0, y));
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
